module.exports = __webpack_public_path__ + "img/1696212280792-mahmudah  dapur mama abi.jpg.62cbc64a.webp";